import PropTypes from "prop-types";
import Collapse from "@mui/material/Collapse";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Icon from "@mui/material/Icon";

import SoftBox from "components/SoftBox";

import {
  collapseItem,
  collapseIconBox,
  collapseIcon,
  collapseText,
} from "examples/Sidenav/styles/sidenavCollapse";

import { useSoftUIController } from "context";

function SidenavCollapse({ color, icon, name, children, active, noCollapse, open, sx, ...rest }) {
  const [controller] = useSoftUIController();
  const { transparentSidenav, miniSidenav } = controller;

  const mergedSx = (theme) => {
    const base = collapseItem(theme, { active, transparentSidenav });
    const extra = typeof sx === "function" ? sx(theme) : sx || {};
    return { ...base, ...extra };
  };

  return (
    <>
      <ListItem component="li" disablePadding sx={{ display: "block" }}>
        <SoftBox {...rest} sx={mergedSx}>
          <ListItemIcon sx={(theme) => collapseIconBox(theme, { active, transparentSidenav, color })}>
            {typeof icon === "string" ? (
              <Icon sx={(theme) => collapseIcon(theme, { active })}>{icon}</Icon>
            ) : (
              icon
            )}
          </ListItemIcon>

          <ListItemText
            primary={name}
            sx={(theme) => collapseText(theme, { miniSidenav, transparentSidenav, active })}
          />

          {/* ✅ Chevron only when submenu exists */}
          {children && !noCollapse && (
            <Icon
              sx={(theme) => ({
                marginLeft: "auto",
                fontSize: theme.functions.pxToRem(18),
                transition: "transform 220ms ease",
                transform: open ? "rotate(180deg)" : "rotate(0deg)",
                opacity: 0.85,
              })}
            >
              expand_more
            </Icon>
          )}
        </SoftBox>
      </ListItem>

      {children && (
        <Collapse in={open} unmountOnExit timeout={220}>
          {children}
        </Collapse>
      )}
    </>
  );
}

SidenavCollapse.defaultProps = {
  color: "info",
  active: false,
  noCollapse: false,
  children: false,
  open: false,
  sx: undefined,
};

SidenavCollapse.propTypes = {
  color: PropTypes.oneOf(["primary", "secondary", "info", "success", "warning", "error", "dark"]),
  icon: PropTypes.node.isRequired,
  name: PropTypes.string.isRequired,
  children: PropTypes.node,
  active: PropTypes.bool,
  noCollapse: PropTypes.bool,
  open: PropTypes.bool,
  sx: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
};

export default SidenavCollapse;
